/*
  Fades and lifts `.dv-reveal` elements as they scroll into view. Each element
  is released after its first intersection — the reveal is a one-shot entrance,
  not a scroll-linked effect.
*/

(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('dv-reveal--in');
        observer.unobserve(entry.target);
      });
    },
    {threshold: 0.07},
  );

  const observe = (root) => {
    if (root.matches?.('.dv-reveal:not(.dv-reveal--in)')) observer.observe(root);
    root.querySelectorAll?.('.dv-reveal:not(.dv-reveal--in)').forEach((el) => observer.observe(el));
  };

  observe(document);

  // Sections re-render on every edit in the theme editor, bringing new nodes.
  document.addEventListener('shopify:section:load', (event) => observe(event.target));

  /*
    Content that arrives after load — the related-products rail is fetched and
    injected by Dawn, and cart re-renders replace whole sections — would
    otherwise never be observed and would sit at opacity 0 forever.
  */
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) observe(node);
      });
    });
  }).observe(document.body, {childList: true, subtree: true});
})();
